import config from '@bingads-webui-component-legacy/config/index';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab');

/**
 * Monetary, always with two decimal places
 */
const monetaryOptions = {
  compact: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
const currencyCode = config.get('AccountCurrencyCode');

export const formatCost = (value) =>
  i18n.formatCurrency(value, currencyCode, monetaryOptions);
